/**
 * @module AEM
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 * Mapping Keys for AEM to UI to resolve component types
 */
/** */

// @TODO how will this bridge with AEM
import { TemplateComponent } from './components/template/template.component';
import { ContainerComponent } from './components/container/container.component';
import { ContainerHolderComponent } from './components/container-holder/container-holder.component';
import { HeaderTextComponent } from './components/header-text/header-text.component';
import { MarketingCarouselComponent } from '@support/shared/widgets/components/marketing-carousel/marketing-carousel.component';
import { AdaptiveImageComponent } from './components/adaptive-image/adaptive-image.component';
import { HorizontalRuleComponent } from './components/horizontal-rule/horizontal-rule.component';
import { HtmlTemplateComponent } from '@core/aem/components/html-template/html-template.component';
import { ComparisonChartComponent } from '@core/aem/components/comparison-chart/comparison-chart.component';
import { LegalTextAuthorableComponent } from './components/legal-text-authorable/legal-text-authorable.component';
import { CtaButtonComponent } from './components/cta-buttons-authorable/cta-button.component';
import { SpacingSizeComponent } from './components/authorable-spacing-size/authorable-spacing-size.component';
import { CtaLinkComponent } from './components/cta-link/cta-link.component';
import { CoverageMapAuthorableComponent } from './components/coverage-map-authorable/coverage-map-authorable.component';
import { ProductOfferingsComponent } from './components/product-offerings/product-offerings.component';
import { ProductFeaturesComponent } from './components/product-features/product-features.component';
import { VideoGalleryComponent } from './components/video-gallery/video-gallery.component';
import { ImageGalleryComponent } from './components/image-gallery/image-gallery.component';
import { RelatedProductsComponent } from './components/related-products/related-products.component';
import { ProductSpecificationComponent } from './components/product-specification/product-specification.component';
import { ProductOfferingsAccessoriesComponent } from './components/product-offerings-accessories/product-offerings-accessories.component';
import { ByodFaqAuthorableComponent } from '@core/aem/components/byod-faq-authorable/byod-faq-authorable.component';
import { BulletTextAuthorableComponent } from '@core/aem/components/bullet-text/bullet-text-authorable.component';
import { PageTitleTemplateComponent } from '@core/aem/components/page-title-template/page-title-template.component';
import { RunDiagnosticTypeComponent } from './components/run-diagnostic/run-diagnostic.component';
import { PlanFamilyTitleComponent } from './components/plan-family-title/plan-family-title.component';
import { PlanProductOfferingComponent } from '@core/aem/components/plan-product-offering/plan-product-offering.component';
import { ProductReviewsComponent } from '@core/aem/components/product-reviews/product-reviews.component';
import { AccordionTextComponent } from '@core/aem/components/accordion-text/accordion-text.component';
import { ProductGalleryComponent } from '@core/aem/components/product-gallery/product-gallery.component';
import { MarketingComponent } from '@root/shared/components/marketing/marketing.component';
import { AccessorySectionComponent } from '@experience/shop/accessory-section/accessory-section.component';
import { ByodPageFaqComponent } from './components/byod-faq/byod-page-faq.component';
import { AccordionListComponent } from './components/accordion-list/accordion-list.component';

/**
 * Component map used for bridging AEM metadata to our dynamic component generation process
 * @access private
 */
export const COMPONENT_MAP = {
  template: TemplateComponent,
  container: ContainerComponent,
  'container-holder': ContainerHolderComponent,
  'marketing-carousel': MarketingCarouselComponent,
  'horizontal-rule': HorizontalRuleComponent,
  'header-text': HeaderTextComponent,
  'legal-text': LegalTextAuthorableComponent,
  'spacing-size': SpacingSizeComponent,
  'cta-link': CtaLinkComponent,
  'adaptive-image': AdaptiveImageComponent,
  'cta-buttons': CtaButtonComponent,
  'html-template': HtmlTemplateComponent,
  'coverage-map': CoverageMapAuthorableComponent,
  'product-offerings': ProductOfferingsComponent,
  'device-description-features': ProductFeaturesComponent,
  'video-gallery': VideoGalleryComponent,
  'image-gallery': ImageGalleryComponent,
  'product-reviews': ProductReviewsComponent,
  'device-detailed-specification': ProductSpecificationComponent,
  'related-products': RelatedProductsComponent,
  'product-offerings-accessories': ProductOfferingsComponent,
  'comparison-chart': ComparisonChartComponent,
  'bullet-text': BulletTextAuthorableComponent,
  'plan-family-title': PlanFamilyTitleComponent,
  'plan-offerings': PlanProductOfferingComponent,
  faq: ByodFaqAuthorableComponent,
  'page-title': PageTitleTemplateComponent,
  runDiagnostic: RunDiagnosticTypeComponent,
  'accordion-text-image': AccordionTextComponent,
  'product-gallery': ProductGalleryComponent,
  'marketing-template': MarketingComponent,
  'recommended-accessory-section': AccessorySectionComponent,
  'byod-faq': ByodPageFaqComponent,
  'accordion-list': AccordionListComponent,
};

export const ENTRY_COMPONENTS = [
  ContainerHolderComponent,
  ContainerComponent,
  TemplateComponent,
  SpacingSizeComponent,
  MarketingCarouselComponent,
  HeaderTextComponent,
  AdaptiveImageComponent,
  PlanFamilyTitleComponent,
  RunDiagnosticTypeComponent,
  HorizontalRuleComponent,
  HtmlTemplateComponent,
  LegalTextAuthorableComponent,
  CtaButtonComponent,
  CtaLinkComponent,
  CoverageMapAuthorableComponent,
  RelatedProductsComponent,
  ProductSpecificationComponent,
  ProductReviewsComponent,
  ImageGalleryComponent,
  VideoGalleryComponent,
  ProductFeaturesComponent,
  ProductOfferingsComponent,
  ProductOfferingsAccessoriesComponent,
  ComparisonChartComponent,
  BulletTextAuthorableComponent,
  ByodFaqAuthorableComponent,
  PageTitleTemplateComponent,
  PlanProductOfferingComponent,
  AccordionTextComponent,
  ProductGalleryComponent,
  AccessorySectionComponent,
  ByodPageFaqComponent,
  AccordionListComponent,
];

export const COMPONENT_MAP_CONSTANTS = {
  AEM_MODULE: 'AemModule',
  PRODUCT_OFFERING_COMPONENT: 'ProductOfferingsComponent',
  PRODUCT_SPECIFICATION_COMPONENT: 'ProductSpecificationComponent',
  PRODUCT_FEATURES_COMPONENT: 'ProductFeaturesComponent',
  VIDEO_GALLERY_COMPONENT: 'VideoGalleryComponent',
  RELATED_PRODUCTS_COMPONENT: 'RelatedProductsComponent',
  PRODUCT_OFFERING_ACCESSORIES_COMPONENT: 'ProductOfferingsAccessoriesComponent',
};
